import { useQuery } from "@tanstack/react-query";
import { projectService } from "@/features/Projects";
import type { ProjectStatus } from "@/features/Projects";

// Hook para buscar projeto por ID
export function useProjectQuery(id: string) {
  return useQuery({
    queryKey: ["project", id],
    queryFn: () => projectService.getById(id),
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
}

// Hook para listar projetos do usuário
export function useProjectsListQuery(userId: string) {
  return useQuery({
    queryKey: ["projects", "user", userId],
    queryFn: () => projectService.getByUser(userId),
    enabled: !!userId,
    staleTime: 2 * 60 * 1000, // 2 minutos
  });
}

// Hook para projetos recentes
export function useRecentProjectsQuery(limit: number = 5) {
  return useQuery({
    queryKey: ["projects", "recent", limit],
    queryFn: () => projectService.getRecent(limit),
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
}

// Hook para projetos por status
export function useProjectsByStatusQuery(status: ProjectStatus) {
  return useQuery({
    queryKey: ["projects", "status", status],
    queryFn: () => projectService.getByStatus(status),
    staleTime: 3 * 60 * 1000, // 3 minutos
  });
}

// Hook para busca de projetos
export function useProjectSearchQuery(searchTerm: string, userId?: string) {
  return useQuery({
    queryKey: ["projects", "search", searchTerm, userId],
    queryFn: () => projectService.search(searchTerm, userId),
    enabled: searchTerm.length >= 2, // Só busca com pelo menos 2 caracteres
    staleTime: 1 * 60 * 1000, // 1 minuto
  });
}

// Hook para estatísticas do usuário
export function useUserProjectStatsQuery(userId: string) {
  return useQuery({
    queryKey: ["projects", "stats", userId],
    queryFn: () => projectService.getUserStats(userId),
    enabled: !!userId,
    staleTime: 10 * 60 * 1000, // 10 minutos
  });
}

// Alias para compatibilidade - Hook principal para buscar projeto por ID
export const useProjectData = useProjectQuery;
